import { get, post, patch, responseResult, del, normaliseTagText } from './api'
import { cleanPayload } from '../../utils'
/**
 * 
 * @param {*} filters 
 * @returns 
 */
export const getCostReport = (filters) => get('report', filters).then(responseResult)